<div class="container mt-3 mb-4">
  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
    <h4 class="m-0">Manage Notices</h4>
    @if (selectedPropertyId() !== null && !showForm()) {
      <button class="btn btn-primary btn-sm" (click)="newNotice()">
        New Notice <fa-icon class="ms-1" [icon]="faPlus"></fa-icon>
      </button>
    }
  </div>

  @if (loadingProperties()) {
    <div class="text-center py-4">
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      <span class="ms-2">Loading properties...</span>
    </div>
  } @else if (properties().length === 0) {
    <div class="alert alert-info">You are not an admin for any property.</div>
  } @else if (properties().length > 1) {
    <div class="card p-3 mb-3">
      <label class="form-label" for="noticePropertySelect">Select Property</label>
      <select id="noticePropertySelect" class="form-select" [ngModel]="selectedPropertyId()" (ngModelChange)="selectProperty($event)">
        <option [ngValue]="null">Choose Property</option>
        @for (property of properties(); track property.id) {
          <option [ngValue]="property.id">{{ property.name }}</option>
        }
      </select>
    </div>
  } @else {
    <div class="card p-3 mb-3 bg-light">
      <div class="small text-muted">Managed Property</div>
      <div class="fw-semibold">{{ selectedPropertyName() }}</div>
    </div>
  }

  @if (showForm()) {
    <div class="card p-3 mb-3">
      <h6>{{ editingId() === null ? 'New Notice' : 'Edit Notice' }}</h6>
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="mb-2">
          <label class="form-label" for="noticeTitle">Title</label>
          <input id="noticeTitle" class="form-control" formControlName="shortDescription" maxlength="255"
            [class.is-invalid]="form.controls.shortDescription.touched && form.controls.shortDescription.invalid">
          <div class="invalid-feedback">Title is required.</div>
        </div>
        <div class="mb-2">
          <label class="form-label" for="noticeBody">Message</label>
          <textarea id="noticeBody" class="form-control" rows="4" formControlName="longDescription"></textarea>
        </div>
        <div class="row g-2 mb-3">
          <div class="col-md-6">
            <label class="form-label" for="noticeVisible">Visible from</label>
            <input id="noticeVisible" type="datetime-local" class="form-control" formControlName="dateVisible"
              [class.is-invalid]="form.controls.dateVisible.touched && form.controls.dateVisible.invalid">
            <div class="invalid-feedback">Visibility date is required.</div>
          </div>
          <div class="col-md-6">
            <label class="form-label" for="noticeUnit">Unit number</label>
            <input id="noticeUnit" type="number" min="0" step="1" class="form-control" formControlName="unit_number"
              placeholder="Leave blank for all units"
              [class.is-invalid]="form.controls.unit_number.touched && form.controls.unit_number.invalid">
            <div class="invalid-feedback">Enter a whole unit number.</div>
          </div>
        </div>
        <div class="d-flex gap-2">
          <button type="submit" class="btn btn-primary btn-sm" [disabled]="saving()">
            @if (saving()) {
              <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
            }
            Save
          </button>
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelEdit()" [disabled]="saving()">Cancel</button>
        </div>
      </form>
    </div>
  }

  @if (selectedPropertyId() !== null) {
    @if (loadingNotices()) {
      <div class="text-center py-4">
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span class="ms-2">Loading notices...</span>
      </div>
    } @else {
      @for (notice of notices(); track notice.id) {
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
              <div>
                <h6 class="mb-1">{{ notice.shortDescription }}</h6>
                <div class="small text-muted">
                  Visible from {{ notice.dateVisible | date: 'medium' }}
                  &middot; {{ notice.unit_number ? 'Unit ' + notice.unit_number : 'All units' }}
                </div>
              </div>
              @if (isScheduled(notice)) {
                <span class="badge bg-warning text-dark">Scheduled</span>
              }
            </div>
            @if (notice.longDescription) {
              <p class="mt-2 mb-0 notice-message">{{ notice.longDescription }}</p>
            }
            <div class="d-flex gap-2 mt-3">
              <button class="btn btn-outline-primary btn-sm" (click)="editNotice(notice)">
                Edit <fa-icon class="ms-1" [icon]="faPen"></fa-icon>
              </button>
              <button class="btn btn-outline-danger btn-sm" (click)="deleteNotice(notice)">
                Delete <fa-icon class="ms-1" [icon]="faTrash"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      } @empty {
        <div class="alert alert-secondary">No notices for this property.</div>
      }
    }
  }
</div>
